export const Notifications = [
  { value: 0, label: 'Disattivata' },
  { value: 1, label: 'Giornaliera' },
  { value: 7, label: 'Settimanale' },
  { value: 30, label: 'Mensile' },
]
